class BAODesignDetails extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.sliderElement = this.querySelector('[data-design-details-slider]')

    if (!this.sliderElement) return

    this.slider = null

    this.enableSliderMobile = this.dataset.sliderMobile === 'true'
    this.enableSliderDesktop = this.dataset.sliderDesktop === 'true'

    this.columnGapMobile = Number(this.dataset.columnGapMobile) || 0
    this.columnGapDesktop = Number(this.dataset.columnGapDesktop) || 0
    this.columnsDesktop = Number(this.dataset.columnsDesktop) || 3
    this.columnsMobile = Number(this.dataset.columnsMobile) || 1.3

    this.mediaQuery = window.matchMedia('(min-width: 768px)')

    this.onBreakpointChange = this.onBreakpointChange.bind(this)

    this.mediaQuery.addEventListener(
      'change',
      this.onBreakpointChange,
    )

    this.updateSlider()
  }

  disconnectedCallback () {
    if (this.mediaQuery) {
      this.mediaQuery.removeEventListener(
        'change',
        this.onBreakpointChange,
      )
    }

    this.destroySlider()

    super.disconnectedCallback()
  }

  onBreakpointChange () {
    this.updateSlider()
  }

  updateSlider () {
    const isDesktop = this.mediaQuery.matches

    const shouldEnableSlider = isDesktop
      ? this.enableSliderDesktop
      : this.enableSliderMobile

    if (!shouldEnableSlider) {
      this.destroySlider()

      return
    }

    this.initialiseSlider(isDesktop)
  }

  initialiseSlider (isDesktop) {
    if (this.slider) {
      this.destroySlider()
    }

    if (typeof window.KeenSlider !== 'function') {
      return
    }

    this.sliderElement.classList.add('keen-slider')

    this.sliderItems.forEach((item) => {
      item.classList.add('keen-slider__slide')
    })

    const perView = isDesktop
      ? this.columnsDesktop
      : this.columnsMobile

    const spacing = isDesktop
      ? this.columnGapDesktop
      : this.columnGapMobile

    this.slider = new window.KeenSlider(
      this.sliderElement,
      {
        mode: 'snap',
        rubberband: false,
        slides: {
          perView,
          spacing,
        },
      },
    )
  }

  destroySlider () {
    if (this.slider) {
      this.slider.destroy()
      this.slider = null
    }

    if (!this.sliderElement) return

    this.sliderElement.classList.remove('keen-slider')

    this.sliderItems.forEach((item) => {
      item.classList.remove('keen-slider__slide')
      item.removeAttribute('style')
    })

    this.sliderElement.removeAttribute('style')
  }

  get sliderItems () {
    return Array.from(
      this.sliderElement.querySelectorAll('.sec-DesignDetails_Item'),
    )
  }
}

if (!customElements.get('bao-design-details')) {
  customElements.define(
    'bao-design-details',
    BAODesignDetails,
  )
}
